const EditDevspecfundsBrandbuild = () => import('../modules/xmsb/energy/operators/EditDevspecfundsBrandbuildGzl')

export default [
  {

    path: '/devspecfundsbrandbuildedit',
    name: 'devspecfundsbrandbuildedit',
    component: EditDevspecfundsBrandbuild,
    meta: {
      title: '发展专项资金项-支持品牌建设',
      fullscreen: true,

    },
  },
]
